import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklists } from './_load/ChecklistsLoader'
import { useNavigationWithModalCloser } from '../../../utils/contexts/NavigationContext'
import { useOpenCloneChecklistModal } from '../../../utils/routes/modals/modalsActions'
import BigCardPicker from '../../../packages/kiti/components/form/BigCardPicker'
import { useCleanFilterForRequest } from '@btime/react-contexts'

const useWidgetConfigs = () => {
  const { t } = useTranslation('listChecklists')
  const NEW_CHECKLIST_BLANK = 'NEW_CHECKLIST_BLANK'
  return [
    {
      id: NEW_CHECKLIST_BLANK,
      name: t('createNew'),
      description: t('createNewDescription'),
      color: 'light5',
      icon: 'RiAddCircleLine',
      categories: [t('new')]
    }
  ]
}

const useHandleSelectTemplate = () => {
  const cleanFilter = useCleanFilterForRequest()
  const navigate = useNavigationWithModalCloser()
  const openCloneChecklistModal = useOpenCloneChecklistModal()
  const NEW_CHECKLIST_BLANK = 'NEW_CHECKLIST_BLANK'

  return template => {
    if (template.id === NEW_CHECKLIST_BLANK) {
      navigate('/checklists/new')
    } else {
      openCloneChecklistModal({ id: template.id, fromTemplates: true, ignoreProject: cleanFilter.ignoreProject })
    }
  }
}

const WidgetsList = props => {
  const { t } = useTranslation('listChecklists')
  const templates = useChecklists()
  const handleSelectTemplate = useHandleSelectTemplate()
  const WIDGET_CONFIGS = useWidgetConfigs()

  return (
    <BigCardPicker
      onChange={handleSelectTemplate}
      options={[
        ...WIDGET_CONFIGS,
        ...templates.map(item => ({
          ...item,
          color: item.project?.color || 'dark3',
          icon: item.icon || 'RiDashboard3Line',
          categories: [item.project?.name || t('templates')],
          fromTemplates: true
        }))
      ]}
    />
  )
}

export default WidgetsList
